import { create } from 'zustand';
import type { PatternTemplateColorsState } from './types';

export const usePatternTemplateColorsStore = create<PatternTemplateColorsState>(
    (set) => ({
        colorByTemplateId: new Map<string, string>(),
        setColorByTemplateId: (colorByTemplateId): void =>
            set({ colorByTemplateId }),
    }),
);
